


















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { CancelNewsletterBlockViewModel } from '@/types/contentServerContract';

import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import WebApiMessage from '@/core/messages/WebApiMessage.vue';
import Api from '@/project/http/Api.service';
import loggingService from '@/core/logging.service';

@Component({
    components: { SmartHeadline, WebApiMessage }
})
export default class CancelNewsletterBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: CancelNewsletterBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    private loading: boolean = false;
    private success: boolean = false;
    private email: string = '';

    private reset() {
        this.email = '';
    }

    private async submit() {
        this.loading = true;

        try {
            await Api.newsletter.unsubscribe(this.email, 'sendapplicationform');
            this.success = true;
        } catch (e) {
            loggingService.error(e);
        } finally {
            this.loading = false;
        }
    }
}
